import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['entries', 'pagination', 'spinner', 'queryBody'];

  initialize() {
    let options = {
      rootMargin: '200px',
    };

    this.intersectionObserver = new IntersectionObserver(entries => this.processIntersectionEntries(entries), options);
  }

  loadQueryBody(_event) {
    console.log("here")
    const search = window.location.search || ''
    const url = `/monitoring/query_body${search}`

    Rails.ajax({
      type: 'GET',
      url: url,
      dataType: 'json',
      success: (resp) => {
        console.log(resp)
        const payload = (typeof resp === 'string') ? JSON.parse(resp) : resp
        const pretty = JSON.stringify(payload.body || {}, null, 2)
        if (this.hasQueryBodyTarget) {
          this.queryBodyTarget.innerHTML = ''
          const pre = document.createElement('pre')
          pre.textContent = pretty
          this.queryBodyTarget.appendChild(pre)
        }
      },
      error: () => {
        if (this.hasQueryBodyTarget) this.queryBodyTarget.textContent = 'Failed to load query.'
      }
    })
  }

  connect() {
    this.intersectionObserver.observe(this.paginationTarget);
    $(this.spinnerTarget).hide();

    // If this is a chart page
    this.chart = Chartkick.charts['topic-analytics'];
    this.barClickHandler();

  }

  showInput(event){
    event.currentTarget.className += " d-none";
    var sliderType = event.target.dataset.sliderType
    var levelType = event.target.dataset.levelType
    var pageType = event.target.dataset.pageType

    $(`#${pageType}-${levelType}-${sliderType}-input`).removeClass('d-none')
    $(`#${pageType}-${levelType}-${sliderType}-input-element`).focus()
    event.stopPropagation();
  }

  barClickHandler() {
    if(this.chart){
      var options = this.chart.chart.options;
      var rawData = this.chart.rawData
      options.onClick = function (evt) {
        var activePoint = this.chart.getElementAtEvent(evt)[0];
        if (activePoint == undefined) return false;
        var data = activePoint._chart.data;
        var datasetIndex = activePoint._datasetIndex;
        var query_id = rawData[datasetIndex].id;
        var published_at = data.labels[activePoint._index];

        var param = 'published_at'
        var regex = new RegExp('('+param+'=)[^\&]+');
        var href = window.location.href.replace( regex , '$1' + [published_at]);
        // replace(window.location.pathname, "published_at=" + published_at)
        //var href = window.location.href.replace(window.location.pathname, "published_at=" + published_at)
        window.location.href = href;
      }
    }
  }

  disconnect() {
    this.intersectionObserver.unobserve(this.paginationTarget);
  }

  processIntersectionEntries(entries) {
    entries.forEach(entry => {
      if(entry.isIntersecting) {
        this.loadMore();
      }
    });
  }

  loadMore() {
    let next_page = this.paginationTarget.querySelector("a[rel='next']");
    if(next_page == null) return;
    let url = next_page.href;
    $(this.spinnerTarget).show();
    Rails.ajax({
      type: 'GET',
      url: url,
      dataType: 'json',
      success: (response) => {
        this.entriesTarget.insertAdjacentHTML('beforeend', response.entries);
        this.paginationTarget.innerHTML = response.pagination;
        $(this.spinnerTarget).hide();
        $(".post-labelling .label-container .label-children.hide-child").hide();
        $(".tag-edit").hide();
      }
    });
  }

  deleteFromPostList(event) {
    let target = $(event.target)
    let url = target.data('url');
    let post_id = target.data('post-id');

    var data = new FormData();
    data.append("post_id", post_id);

    Rails.ajax({
      type: 'POST',
      url: url,
      data: data,
      dataType: 'json',
      success: (response) => {
        target.html('Removed')
        target.prop('disabled', true)
        target.parents("tr").addClass("row-inactive")
      }
    });

  }
}